/**
 * Archivo: Notificaciones.js
 * Autor: Acher Egido Mairal
 * Fecha de última modificación: 2024-07-10
 * 
 * Descripción:
 * Este componente define la vista para la visualización de notificaciones de los usuarios. 
 * Permite a los usuarios ver mensajes globales y personales, con una indicación de los mensajes nuevos.
 * 
 * Dependencias:
 * - react: ^18.2.0
 * - js-cookie: ^3.0.1
 * - Servicios/MensajesServicios: Funciones para interactuar con el servicio de mensajes.
 * - Componentes/MetaTags: Componente para las etiquetas meta del documento.
 * - Componentes/Cabecera: Componente para la cabecera de la aplicación.
 * - Componentes/SegundaCabecera: Componente para la segunda cabecera de la aplicación.
 * 
 * Propósito:
 * Proveer una interfaz de usuario para la visualización de notificaciones, incluyendo mensajes globales y personales,
 * con una indicación de los mensajes nuevos.
 */

import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import '../Estilos/estilos.css';
import MetaTags from '../Componentes/MetaTags';
import Cabecera from '../Componentes/Cabecera';
import SegundaCabecera from '../Componentes/SegundaCabecera';
import { listaMensajesUsuario } from '../Servicios/MensajesServicios';

function Notificaciones() {
  const [mensajes, setMensajes] = useState([]);
  //const [token, setToken] = useState('');
  const [permisos, setPermisos] = useState(null);
  const [contadorMensajesNuevos, setContadorMensajesNuevos] = useState(0);

  useEffect(() => {
    const obtenerDatos = async () => {
      const tokenNuevo = Cookies.get('token');
      const permisosNuevos = Cookies.get('permisos');
      //setToken(tokenNuevo);
      setPermisos(permisosNuevos);
      await actualizarListaMensajes(tokenNuevo);
    };
    obtenerDatos();
  }, []);

  const actualizarListaMensajes = async (token) => {
    const resultado = await listaMensajesUsuario(token);
    if (resultado.success) {
      setMensajes(resultado.data);
      setContadorMensajesNuevos(resultado.contador);
    } else {
      console.log(resultado ? resultado.message : 'Error desconocido');
    }
    //console.log("Mensajes:", mensajes)
  };

  const renderMensajes = (mensajes) => {
    if (!mensajes || mensajes.length === 0) {
      return (
        <div className='row-fluid p-2 d-flex justify-content-between'>
          <div>No hay notificaciones.</div>
        </div>
      );
    }

    return mensajes.map((mensaje, index) => (
      <div key={index} className="row mb-2 align-items-center" style={{ backgroundColor: mensaje.es_global ? '#E9ECEF' : '#DDDDDD'}}>
        <div className="col-8 py-2">
          <span className="text-black">{mensaje.texto_mensaje}</span>
        </div>
        <div className="col-2 d-flex justify-content-center">
          <span className="text-black">{new Date(mensaje.fecha_mensaje).toLocaleDateString()}</span>
        </div>
        {index < contadorMensajesNuevos && (
          <div className="col-2 d-flex justify-content-center">
            <span className="badge badge-danger">Nuevo</span>
          </div>
        )}
      </div>
    ));
  };

  return (
    <>
      <MetaTags />
      <div className="fondo">
        <Cabecera permisos={permisos}/>
        <div className='d-none d-md-block '>
          <SegundaCabecera hayVentanas={false} permisos={permisos} />
          <div className='container-fluid d-flex p-2'>
            <div className='container-fluid col-11'>
              <div className='container-fluid'>
                <div className='row-fluid d-flex flex-column'>
                  <div className='row-fluid d-flex'>
                    <div className='col-8'>
                      <h5 className="text-black mt-4">Notificaciones:</h5>
                    </div>
                    <div className='col-2 d-flex justify-content-center'>
                      <h5 className="text-black mt-4">Fecha</h5>
                    </div>
                  </div>

                  <div className='container-fluid' style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    {renderMensajes(mensajes)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='d-block d-md-none '>
          <div className='container-fluid d-flex p-0'>
            <div className='container-fluid col-12 p-0'>
              <div className='container-fluid'>
                <div className='row-fluid d-flex flex-column'>
                  <div className='row-fluid d-flex'>
                    <div className='col-8'>
                      <h5 className="text-black mt-4">Notificaciones:</h5>
                    </div>
                    <div className='col-2 d-flex justify-content-center'>
                      <h5 className="text-black mt-4">Fecha</h5>
                    </div>
                  </div>

                  <div className='container-fluid' style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    {renderMensajes(mensajes)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Notificaciones;
